export default {

  methods: {
    fontHairline() {
      if (window.navigator.userAgent.includes('Macintosh')) {
        return 'font-extralight';
      }
      return 'font-light';
    },
    fontThin() {
      if (window.navigator.userAgent.includes('Macintosh')) {
        return 'font-extralight';
      }
      return 'font-light';
    },
    textGray400() {
      if (window.navigator.userAgent.includes('Macintosh')) {
        return 'text-gray-400';
      }
      return 'text-gray-700';
    },
  },

};
